import { PropsWithChildren } from 'react';
import styled, { InterpolationValue } from 'styled-components';
import { onMobile } from '../../styles/onMobile';
import IconClose from '../icons/IconClose.svg';
import {
  AlertContainer,
  AlertContent,
  AlertIconContainer,
  AlertMessage,
  CloseIcon,
  IconArea,
} from './Alert.styles';
import { AlertVariants, Variant } from './AlertVariants';

type Props = PropsWithChildren<{
  variant?: Variant;
  showCloseButton?: boolean;
  onClose?: () => void;
}>;

export const Alert = ({
  children,
  variant = AlertVariants.Success,
  showCloseButton = false,
  onClose,
}: Props) => (
  <AlertContainer {...variant}>
    <AlertContent>
      <AlertIconContainer aria-hidden="true">
        <AlertIcon as={variant.Icon} $colorKey={variant.primary} />
      </AlertIconContainer>
      <AlertMessage>{children}</AlertMessage>
    </AlertContent>
    {showCloseButton && (
      <IconArea>
        <CloseIcon as={IconClose} onClick={onClose} />
      </IconArea>
    )}
  </AlertContainer>
);

export const AlertIcon = styled.svg<{ $colorKey: InterpolationValue }>`
  color: ${props => props.$colorKey};
  height: 40px;
  width: 40px;

  ${onMobile} {
    height: 30px;
    width: 30px;
  }
`;
